module.exports = __webpack_public_path__ + "static/media/trees.edb39db0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/trees.jpeg
// module id = 637
// module chunks = 0